var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.items,"options":_vm.options,"server-items-length":_vm.totalItems,"loading":_vm.loading,"footer-props":{
          'items-per-page-options': [15,30,60,100,150,250],
        }},on:{"update:options":function($event){_vm.options=$event}}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }